import * as React from 'react';

import { t } from '@toolkit/util/i18n';
import { COST_CENTER_CATEGORIES } from '@src/shared/src/const/app';
import { WrappedFieldProps } from 'redux-form';
import { OptionModel } from '@src/shared/src/models';
import { SelectInputCostCenter } from './SelectInputCostCenter';

type Props = WrappedFieldProps & {
  userIds: number[];
  required: boolean;
  category: COST_CENTER_CATEGORIES;
};

export const SelectWithPercentage: React.FC<Props> = (props) => {
  const { input } = props;
  const [percentValue, setPercentValue] = React.useState(input.value.percentageValue);
  const onChange = (selectValue: string, percentageValue: number, selectLabel: string) => {
    input.onChange({
      selectValue,
      percentageValue,
      selectLabel,
    });
  };

  const handleSelectChange = (option: OptionModel) => {
    if (option) {
      onChange(option.value, percentValue, option.label);
    } else {
      onChange(null, null, null);
    }
  };

  const handleOnBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    const perVal = evt.target.value.replace(/\D/g, '');
    let validatedPercentage = Number(perVal) < 1 ? 1 : Number(perVal);
    validatedPercentage = validatedPercentage > 100 ? 100 : validatedPercentage;
    setPercentValue(validatedPercentage);
    onChange(input.value.selectValue, validatedPercentage, input.value.selectLabel);
  };

  return (
    <div>
      <SelectInputCostCenter
        {...props}
        value={{
          value: input.value.selectValue,
          label: input.value.selectLabel,
        }}
        onChange={handleSelectChange}
      />

      <div className="is--bottom-field is--percentage">
        <input
          type="number"
          min="1"
          max="100"
          placeholder={t('global.percentage')}
          value={percentValue}
          onChange={(evt) => {
            setPercentValue(evt.target.value);
          }}
          onBlur={handleOnBlur}
        />
      </div>
      {props.meta.error && <div className="form-error-message">{props.meta.error}</div>}
    </div>
  );
};
